import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeCircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeCircle" ref={ref} {...props}>
      <path d="M12,21.86A9.86,9.86,0,1,1,21.86,12,9.88,9.88,0,0,1,12,21.86ZM12,3.64A8.36,8.36,0,1,0,20.36,12,8.37,8.37,0,0,0,12,3.64Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeCircleIcon.displayName = 'ShapeCircleIcon';
ShapeCircleIcon.renderIcon = (props) => <ShapeCircleIcon {...props} />;
export default ShapeCircleIcon;
